export type Testimonial = {
  quote: string
  author: string
  context: string
}

export const testimonials: Testimonial[] = [
  {
    quote:
      'Porte claquée un dimanche matin avec le bébé à l’intérieur. Moussa était là en 25 minutes et a ouvert sans rien casser. Le prix annoncé au téléphone était exactement celui de la facture.',
    author: 'Claire M.',
    context: 'Maisons-Laffitte',
  },
  {
    quote:
      'Après un cambriolage, il a sécurisé l’appartement le soir même puis posé un bloc-porte blindé la semaine suivante. Travail propre, explications claires, dossier assurance impeccable.',
    author: 'Ahmed B.',
    context: 'Paris 17e',
  },
  {
    quote:
      'Nous lui confions les serrures de nos trois halls d’immeuble depuis deux ans. Réactif, ponctuel, et il ne cherche jamais à vendre plus que nécessaire.',
    author: 'Cabinet Rivière',
    context: 'Syndic, Sartrouville',
  },
]
